import React, { useState, useRef, useEffect } from 'react';
import { createCategory, deleteCategory, getCategories, updateCategory, softDeleteCategory } from '../../Services/CategoryService';
import { useForm, Controller } from 'react-hook-form';
import Swal from 'sweetalert2';
import MTable from '../../Components/MTable/MTable';
import { InputSwitch } from 'primereact/inputswitch';
import Overlay from '../../Components/Overlay/Overlay';
import { handlerFormError, uuid } from '../../Utils/Utils';
import { toastError, toastSuccess } from "../../Components/Toasts/Toast";
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import EditButton from '../../Components/Button/EditButton';
import { setModuleName } from '../../Stores/Action/AppAction';
import { Uploader } from 'rsuite';
import 'rsuite/dist/rsuite.min.css'

const { $, setupDigitInput } = window;
let processingId = -1;

const CategoryScreen = () => {
    const mTable = useRef();
    const { register, handleSubmit, reset, control, formState: { errors } } = useForm({
        defaultValues: {
            category_code: '',
            category_name: '',
            description: '',
            is_active: true,
            sort: 0
        }
    });

    const dispatch = useDispatch();

    const [state, setState] = useState({
        showForm: false,
        category: {
            category_code: '',
            category_name: '',
            description: '',
            is_active: true,
            sort: 0
        },
        file_icon: '',
        processing: false,
        toggle: false
    });

    const iconUpload = e => {
        if (e.length > 0) {
            setState({ ...state, file_icon: e[0].blobFile });
        }
    }

    const iconRemove = e => {
        setState({ ...state, file_icon: '' });
    }

    useEffect(() => {
        dispatch(setModuleName('Category'));
        setupDigitInput();
    }, []);

    const changeStatus = (username, status) => {
        const body = {
            is_active: status
        }

        softDeleteCategory(username, body, res => {
            if (res.status == 200 || res.status == 201) {
                Swal.fire({
                    icon: 'success',
                    title: 'Change status success',
                    text: 'Data has been changed!'
                }).then(res => { mTable.current.refresh(); });
            }
        }, error => {
            Swal.fire({
                icon: 'error',
                title: 'Change status fail',
                text: 'Data can not be changed!'
            });
        });
    }

    const columns = [
        { id: 1, title: 'Category Code', field: 'category_code', sortable: true },
        { id: 2, title: 'Category Name', field: 'category_name', sortable: true },
        { id: 3, title: 'Description', field: 'description', sortable: true },
        { id: 4, title: 'Sort', field: 'sort', sortable: true },
        {
            id: 5,
            title: 'Active',
            field: 'is_active',
            sortable: true,
            options: [
              {
                label: 'Active',
                value: true
              },
              {
                label: 'Inactive',
                value: false
              }
            ],
            render: data => {
              return <InputSwitch checked={data.is_active} onChange={(e) => changeStatus(data._id, e.value)} />;
            },
        },
        {
            id: 6,
            title: '',
            sortable: true,
            style: { width: 200 },
            render: item => {
                return (
                    <div>
                        <EditButton title="Edit" onClick={onEdit(item)} />
                    </div>);
            },
        },
    ];

    const propsTable = { columns, getData: getCategories, enableFilter: true, showAddButton: true, filterRule: 'filter' };


    const onEdit = item => () => {
        reset(item);
        setState({ ...state, category: item, showForm: true });
        setupDigitInput();
    }

    const onAddData = () => {
        onReset();
        setState({ ...state, showForm: true });
        setupDigitInput();
    }

    const startProcessing = () => {
        processingId = setTimeout(() => {
            setState({ ...state, processing: true });
        }, 150);
    }

    const stopProcessing = () => {
        clearTimeout(processingId);
        setState({ ...state, processing: false });
    }

    const onSubmit = (data) => {
        startProcessing();
        const formData = new FormData();

        for (var key in data) {
            if(key == 'is_active'){
                var sta = data[key] === true ? 1 : 0;
                formData.append(key, sta);
            }else{
                formData.append(key, data[key]);
            }
            
        }

        formData.append('category_icon', file_icon);

        if (category._id) {
            formData.append('_method', 'put');
        }


        const response = category._id ? updateCategory(category._id, formData) : createCategory(formData);
        response.then(res => {
            if (res.status == 200 || res.status == 201) {
                Swal.fire({
                    icon: 'success',
                    title: 'Save data success',
                    text: 'Data has been saved!'
                }).then(r => {
                    mTable.current.refresh();
                    category._id ? onCloseForm() : onReset();
                })
            }
        }).catch(({ response: { data } }) => {
            handlerFormError(data);
        }).finally(_ => stopProcessing());
    }

    const onReset = () => {
        reset({
            category_code: '',
            category_name: '',
            file_icon: '',
            is_active: true,
            sort: 0
        });
        setState({ ...state, category: {} });
    }

    const onCloseForm = () => {
        reset({
            category_code: '',
            category_name: '',
            file_icon: '',
            is_active: true,
            sort: 0
        });
        setState({ ...state, category: {}, showForm: false });
    }

    const { category, processing, showForm, file_icon } = state;

    return (
        <div className="content-wrapper">
            <div className="content-header">
                {/* <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Manage Category </h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><NavLink to="/home">Home</NavLink></li>
                                <li className="breadcrumb-item active">Category</li>
                            </ol>
                        </div>
                    </div>
                </div> */}
            </div>
            <section className="content">
                <div className="container-fluid">
                    <button className="btn btn-primary" type='button' onClick={() => { setState({ ...state, toggle: !state.toggle }); console.log('toggle', state.toggle); }}><span className={`fa fa-arrow-${state.toggle ? 'down' : 'up'}`}></span> CLick Me</button>
                    <div className="row">
                        <div className='col-md-12'>
                            <div className='card'>
                                <Overlay display={processing} />
                                <div className="card-header">
                                    <div className="card-title">
                                        <i className="fas fa-tags mr-1" />
                                        {showForm ? ' Form Category' : ' List Category'}
                                    </div>
                                </div>

                                <form name="form-detail" onSubmit={handleSubmit(onSubmit)}>
                                    <div className='card-body'>
                                        <div className={`${!showForm ? 'card__side--front-show' : 'card__side--front'}`}>
                                            <MTable ref={mTable} {...propsTable} onAddData={onAddData} showIndex={true} />
                                        </div>

                                        <div className={`${showForm ? 'card__side--back-show' : 'card__side--back'}`}>
                                            <div className='row'>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <label htmlFor="category_code">Category Code</label>
                                                        <input id="category_code" {...register("category_code", { required: { value: true, message: 'Category code is required!' } })} placeholder='Category code' className='form-control' />
                                                        {errors.category_code && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.category_code.message}</span>)}
                                                    </div>
                                                    <div className='form-group'>
                                                        <label htmlFor="category_name">Category Name</label>
                                                        <input id="category_name" {...register("category_name", { required: { value: true, message: 'Category name is required!' } })} placeholder='Category name' className='form-control' />
                                                        {errors.category_name && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.category_name.message}</span>)}
                                                    </div>

                                                    <div className='form-group'>
                                                        <label htmlFor="category_icon">Icon</label>
                                                        <div className='form-control'>
                                                        <Uploader
                                                            name="file_icon"
                                                            multiple={false}
                                                            autoUpload={false}
                                                            listType="picture"
                                                            value={file_icon}
                                                            onChange={e => iconUpload(e)}
                                                            disabled={file_icon == '' ? false : true}
                                                            onRemove={e => iconRemove(e)}
                                                            action=''>
                                                        </Uploader>
                                                        </div>
                                                    </div>
                                                    <div className='form-group'>
                                                        <label htmlFor="description">Description</label>
                                                        <input id="description" {...register("description", { required: { value: true, message: 'Description is required!' } })} placeholder='Description' className='form-control' />
                                                        {errors.description && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.description.message}</span>)}
                                                    </div>
                                                    {category._id && <div className='form-group'>
                                                        <label htmlFor="sort">Position Sorting</label>
                                                        <input id="sort" {...register("sort")} placeholder='Sort' className='form-control digit' />
                                                        {errors.sort && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.sort.message}</span>)}
                                                    </div>}
                                                    <div className='form-group'>
                                                        <label htmlFor="is_active">Active</label>
                                                        <div>
                                                            <Controller name="is_active" control={control} render={({ field }) => { return (<InputSwitch {...field} checked={field.value} />) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        showForm && <div className='card-footer delay'>
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='d-flex' style={{ justifyContent: 'flex-end' }}>
                                                        <button type='button' className='btn btn-outline-dark mr-3' style={{ width: 100 }} onClick={onCloseForm}><i className='fa fa-times' /> Close</button>
                                                        <button type='button' className='btn btn-danger mr-3' style={{ width: 100 }} onClick={onReset}><i className='fa fa-sync' /> Clear</button>
                                                        <button type='submit' className='btn btn-dark' style={{ width: 100 }}> <i className='fa fa-save' /> Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default CategoryScreen;